const speakers = [
  {
    name: "Prof. Sergio Moya Rosales",
    institution: "CIC biomaGUNE",
    topic: "Understanding In Vitro Behavior and Transformations of Hybrid Nanocarriers for Targeted Drug Delivery"
  },
  {
    name: "Prof. Clara Santato",
    institution: "Polytechnic de Montreal, Canada",
    topic: "Studies on electronic transport in biosourced organic materials"
  },
  {
    name: "Prof. Alejandro Sosnik",
    institution: "Technion-Israel Institute of Technology, Israel",
    topic: "Targeting the Brain with Nanotherapeutics in Pediatric Diseases"
  },
  {
    name: "Prof. Guebre X. Tessema",
    topic: "Tuning the Electronic and Structural Properties of a Quantum Material: NbSe3"
  },
  {
    name: "Justus Ndukaife",
    institution: "Vanderbilt University",
    topic: "Next generation optical nanotweezers for characterizing nanoplastics"
  },
  {
    name: "Marcus Newton",
    institution: "University of Southampton, UK",
    topic: "Imaging Quantum Materials with Coherent X-rays"
  },
  {
    name: "Daniele Mantione",
    institution: "University of the Basque Country, Donostia, Spain",
    topic: "Ionic and electronic conductive (co)polymers  "
  },
  {
    name: "Souleymane Diallo",
    institution: "Johns Hopkins University, USA",
    topic: "Comparative Physicochemical Characterization of Raw Moringa oleifera Leaves and Seeds"
  }
];

export default speakers
